import { Bars3Icon } from "@heroicons/react/24/outline";
import Link from "next/link";
import LogoWithName from "@/components/nav/logo-with-name";
import classNames from "classnames";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useSession } from "next-auth/react";
import {
  NAV_CLASS_NAMES,
  BASE_NAV_ITEM_CLASS_NAMES,
} from "@/components/nav/navbar";
import { XmasDoubleBell } from "@/components/svg";

export default function Navbar({ navigation, setOpen }) {
  const [flatten, setFlatten] = useState(0);
  const router = useRouter();
  const { data: session } = useSession();

  useEffect(() => {
    const onScroll = () => setFlatten(window.pageYOffset > 100);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navScrollTransitionClasses = "transition-all duration-300 ease-in-out";

  return (
    <header
      className={classNames("relative bg-white", navScrollTransitionClasses)}
    >
      <nav aria-label="Top" className={NAV_CLASS_NAMES}>
        <div
          className={classNames(
            // bottom margin needed when shrinking navbar so window.pageYOffset doesn't shift
            flatten ? "h-16 md:h-14 md:mb-4 xl:mb-6" : "h-16 md:h-18 xl:h-20",
            "flex justify-between items-center md:justify-end md:flex-row",
            navScrollTransitionClasses
          )}
        >
          {/* Logo */}
          <div className="h-full items-center flex">
            <Link href="/">
              <a className="rounded-sm">
                <span className="sr-only">JustShip Home</span>
                <LogoWithName
                  classNames={classNames(
                    flatten ? "lg:w-4/5" : "w-full",
                    navScrollTransitionClasses
                  )}
                />
              </a>
            </Link>
          </div>

          <div className="flex h-full items-center ml-auto space-x-2 sm:space-x-6">
            <div className="space-x-6 md:space-x-8 hidden sm:flex mx-2">
              {navigation.pages?.map((page) => {
                return (
                  <Link key={page.name} href={page.href}>
                    <a
                      className={classNames(
                        BASE_NAV_ITEM_CLASS_NAMES,
                        "text-subheading-gray hover:text-light-purple focus:text-dark-purple"
                      )}
                    >
                      {page.name}
                    </a>
                  </Link>
                );
              })}
            </div>
            <Link href="/create-shipment">
              <a
                className={classNames(
                  "py-2 px-5 rounded-full text-sm md:text-xs font-medium relative",
                  "bg-light-purple hover:bg-dark-purple text-violet-100 hover:text-white"
                )}
              >
                {process.env.NEXT_PUBLIC_THEME === "XMAS" && (
                  <div
                    className={classNames(
                      "absolute -top-4 -right-5 pointer-events-none"
                    )}
                  >
                    <XmasDoubleBell />
                  </div>
                )}
                Ship Now
              </a>
            </Link>

            <button
              type="button"
              className={classNames(
                "p-2 md:mr-4 rounded-md",
                "text-dark-purple"
              )}
              onClick={() => setOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}
